/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    textTransform: 'capitalize',
  },
}));

export const algoListSymbolsMap = {
  BANKNIFTY: 'BNF',
  NIFTY: 'NF',
  FINNIFTY: 'FNF',
  SENSEX: 'SEN',
  MIDCPNIFTY: 'MIDNF',
  BANKEX: 'BANK',
};

// BNF, NF, FNF, SEN, MIDNF, BANK
export function arrangeAlgoListSymbols(underlyings = []) {
  const arrangedUnderlyings = [];

  if (underlyings.includes('BANKNIFTY')) {
    arrangedUnderlyings.push(algoListSymbolsMap.BANKNIFTY);
  }

  if (underlyings.includes('NIFTY')) {
    arrangedUnderlyings.push(algoListSymbolsMap.NIFTY);
  }

  if (underlyings.includes('FINNIFTY')) {
    arrangedUnderlyings.push(algoListSymbolsMap.FINNIFTY);
  }

  if (underlyings.includes('SENSEX')) {
    arrangedUnderlyings.push(algoListSymbolsMap.SENSEX);
  }

  if (underlyings.includes('MIDCPNIFTY')) {
    arrangedUnderlyings.push(algoListSymbolsMap.MIDCPNIFTY);
  }

  if (underlyings.includes('BANKEX')) {
    arrangedUnderlyings.push(algoListSymbolsMap.BANKEX);
  }

  return arrangedUnderlyings;
}

const CellUnderlyingSymbols = ({ row = {} }) => {
  const history = useHistory();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '', underlyings = [] } = original;
  const underlyingsFormatted = arrangeAlgoListSymbols(underlyings);

  const handleRedirectToAlgoEdit = () => {
    history.push(`/algos/${_id}`, {
      from: window.location.hash,
    });
  };

  return (
    <div className={classes.root} onClick={handleRedirectToAlgoEdit}>
      {underlyingsFormatted?.join(', ')}
    </div>
  );
};

export default CellUnderlyingSymbols;
